export default __webpack_public_path__ + "static/finintcase1-16e5c6b6f81563a3b98c0cae1a49a6e4.png";